import {Controller} from '@stimulus/core'
import HSMegaMenu from '../../../../../vendor/front/vendor/hs-mega-menu/src/js/hs-mega-menu'
import {isPreview} from "../../support";

// data-controller='hs--mega-menu'
// data-hs-mega-menu-item-options='{}' https://htmlstream.com/preview/front-v3.2.2/documentation/header-mega-menu.html#methods

export default class extends Controller {
  connect() {
    if (isPreview()) {
      return false
    }

    new HSMegaMenu(this.element).init()

    return true
  }
}
